module.exports = __webpack_public_path__ + "img/background.cd3aaaec.jpg";